import { useGoToSection } from 'shared/hooks/useGoToSection';
import { Typography } from '@ag1/ui';
import { getCardNumberText } from 'shared/studio/AnchorNavigation/utils';
import { CustomPortableText } from 'shared/studio/PortableText';
import { SanityBlock, SanityKeyed } from 'types/studio/studio';
import styles from './TableOfContentsItem.module.scss';

type TableOfContentsItemProps = {
  item: {
    portableText: SanityKeyed<SanityBlock>[];
    _id: string;
  };
  index: number;
};

export const TableOfContentsItem = ({ item, index }: TableOfContentsItemProps) => {
  // eslint-disable-next-line no-underscore-dangle
  const { goToSection } = useGoToSection(item._id);

  return (
    // eslint-disable-next-line no-underscore-dangle
    <li className={styles.listItem} key={item._id}>
      <button type="button" onClick={goToSection} className={styles.buttonLink}>
        <Typography
          variant="portalText"
          size="1"
          color="black-new"
          noPadding
          className={styles.number}>
          {getCardNumberText(index + 1, true)}
        </Typography>
        <Typography
          variant="portalText"
          size="1"
          color="black-new"
          noPadding
          className={styles.text}>
          <CustomPortableText value={item.portableText} />
        </Typography>
      </button>
    </li>
  );
};
